import {
  instance,
  file,
} from './index';

const getCategories = async (masterUser) => {
  const res = await instance.get(`/categories/all/${masterUser}`);
  return res;
};
const getCategoriesWithProducts = async (masterUser) => {
  const res = await instance.get(`/categories/with-products/${masterUser}`);
  return res;
};
const getCategory = async (id) => {
  const res = await instance.get(`/categories/${id}`);
  return res;
};
const categoryUpdate = async (id, data) => {
  const res = await file.put(`/categories/${id}`, data).then((result) => result, (error) => {
    console.log('categoryUpdate error', { error });
    return { error };
  });
  return res;
};
const categoryUpdateWoutFile = async (id, data) => {
  const res = await instance.post(`/categories/${id}`, data);
  return res;
};
const clearMenu = async (masterUser) => {
  const res = await instance.delete(`/menu/delete/${masterUser}`);
  return res;
};
const updateCategorySortId = async (data) => {
  const res = await instance.post('/categories/update/sortId', data);
  return res;
};
export {
  getCategories,
  getCategoriesWithProducts,
  getCategory,
  categoryUpdate,
  categoryUpdateWoutFile,
  clearMenu,
  updateCategorySortId,
};
